import { schemes, zSchema } from "@zeal/common";

export const getWalletStatisticsRequestSchema = zSchema.object({
  companyID: schemes.companyID(),
});

export type TGetWalletStatisticsRequestSchema = zSchema.infer<
  typeof getWalletStatisticsRequestSchema
>;

export const getWalletStatisticsResponseSchema = zSchema.object({
  available_balance: zSchema.number(),
  total_balance: zSchema.number(),
  total_wallets: zSchema.number(),
  median_balance: zSchema.number(),
  revenue: zSchema.number(),
});

export type TGetWalletStatisticsResponseSchema = zSchema.infer<
  typeof getWalletStatisticsResponseSchema
>;
